import { ChangeEvent, Dispatch, SetStateAction } from "react";
import styled, { CSSProperties } from "styled-components";
import themeProps from "theme/themes";

type TextFieldProps = {
  placeholder: string;
  value: string;
  type?: string;
  onChange: Dispatch<SetStateAction<any>>;
  styles?: CSSProperties;
};

const Wrapper = styled.div`
  width: 100%;
`;

const Input = styled.input`
  padding: 1.5rem 2rem;
  border: 1px solid ${(props: themeProps) => props.theme.border.secondary};
  border-radius: 12px;
  outline: none;
  width: 100%;
`;

const TextField = ({
  placeholder,
  onChange,
  value,
  type,
  styles,
}: TextFieldProps) => {
  return (
    <Wrapper style={styles}>
      <Input
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.currentTarget.value)
        }
        type={type}
        value={value}
      />
    </Wrapper>
  );
};

export default TextField;
